import React from 'react'
import { InfoIcon, XCloseIcon } from 'assets/icons/index'
import Button from 'components/ui-kit/Button/index'
import Popup from 'components/ui-kit/Popup/index'
import './hotkeysmodal.scss'

const HotkeysModal = ({ isOpenModal, setIsHotkeysModal, className, isKeyBindEnabled, setIsKeyBindEnabled }) => {
  return (
    <Popup
      className={className}
      isOpenModal={isOpenModal}
    >
      <Button className='btn-close-modal p-0' onClick={() => setIsHotkeysModal(false)}>
        <div className='px-2'>
          <XCloseIcon width={20} height={20} />
        </div>
      </Button>
      <div className='hotkeys-content-body text-white pt-1'>
        <div className='hotkeys-title mb-3 '>
          <h6 className='pb-1 fs-4'>Hotkeys</h6>
        </div>
        <div className='hotkeys-body'>
          {/* items */}
          <div className='hotkeys-items d-flex'>
            <div className='hotkeys-col-2 d-flex flex-column justify-content-center'>Place Bet or Cashout</div>
            <div className='hotkeys-col-1 d-flex flex-column justify-content-center align-items-center space'>Space</div>
          </div>
          {/* items */}
          <div className='hotkeys-items d-flex'>
            <div className='hotkeys-col-2 d-flex flex-column justify-content-center'>Double Bet Amount</div>
            <div className='hotkeys-col-1 d-flex flex-column justify-content-center align-items-center'>W</div>
          </div>
          {/* items */}
          <div className='hotkeys-items d-flex'>
            <div className='hotkeys-col-2 d-flex flex-column justify-content-center'>Halve Bet Amount</div>
            <div className='hotkeys-col-1 d-flex flex-column justify-content-center align-items-center'>S</div>
          </div>
          <div className='hotkeys-items d-flex'>
            <div className='hotkeys-col-2 d-flex flex-column justify-content-center'>Increase rows</div>
            <div className='hotkeys-col-1 d-flex flex-column justify-content-center align-items-center'>A</div>
          </div>
          <div className='hotkeys-items d-flex'>
            <div className='hotkeys-col-2 d-flex flex-column justify-content-center'>Decrease rows</div>
            <div className='hotkeys-col-1 d-flex flex-column justify-content-center align-items-center'>D</div>
          </div>
          {/* checkbox hotkeys enabled */}
          <div className='d-flex justify-content-center'>
            <button
              className='hotkey-modal-btn'
              onClick={() => setIsKeyBindEnabled(prev => !prev)}
            >
              {`${isKeyBindEnabled ? 'Disable' : 'Enable'} Hotkeys`}
            </button>
          </div>

          {/* hotkeys warning */}
          <div className='hotkeays-warning-section d-flex rounded-1 gap-3'>
            <div>
              <InfoIcon />
            </div>
            <p className='mb-0'>
              When the hotkeys are enabled, they will remain on for all games until disabled. Despite some games sharing similar key binds, it's always advised to confirm what key interactions are set for each game.
            </p>
          </div>

        </div>
      </div>
    </Popup>
  )
}

export default HotkeysModal
